import { render, staticRenderFns } from "./OutsideReceipt.vue?vue&type=template&id=8b782b00&scoped=true"
import script from "./OutsideReceipt.vue?vue&type=script&lang=js"
export * from "./OutsideReceipt.vue?vue&type=script&lang=js"
import style0 from "./OutsideReceipt.vue?vue&type=style&index=0&id=8b782b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b782b00",
  null
  
)

export default component.exports